// extracted by mini-css-extract-plugin
export var colorSquare = "_uf-0";
export var danger = "_uf-5";
export var lightPink = "_uf-8";
export var neutralBlue = "_uf-7";
export var neutralYellow = "_uf-6";
export var normal = "_uf-1";
export var primary = "_uf-2";
export var primaryLight = "_uf-3";
export var solidBlack = "_uf-g";
export var solidGreen = "_uf-b";
export var solidLightBlue = "_uf-d";
export var solidNavy = "_uf-c";
export var solidOrange = "_uf-f";
export var solidPink = "_uf-e";
export var solidRed = "_uf-9";
export var solidYellow = "_uf-a";
export var success = "_uf-4";